<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <span>{{ status(params.value) }}</span>
  </vs-chip>
</template>

<script>

export default {
  name: "CellRendererDisableStatus",
  computed: {
    chipColor() {
      return value => {
        if (value === null ) {
          return "success";
        } else {
          return "danger"
        }
      };
    },
    status() {
      return value => {
        if (value === null ) {
          return "有効";
        } else {
          return "無効"
        }
      };
    }
  },
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
    border-radius: 5px;
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
</style>
